import React, { FC } from 'react';
import { tint } from 'src/shared/globals';
import BiCircle from 'src/shared/icons/circle.svg';
import styled from 'styled-components';

// Re-export ui-widgets badge components
export * from './betaBadge';
export * from './betaBannerIcon';

export interface BadgeProps {
    badgeColor: string;
    borderColor?: string;
    color?: string;
    showCircle?: boolean;
    children?: React.ReactNode;
    className?: string;
}

const StyledBadge = styled.div<{ $badgeColor: string; $borderColor?: string; $color?: string }>`
    background-color: ${(props) => props.$badgeColor};
    display: inline-flex;
    align-items: center;
    width: fit-content;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    line-height: 1.4;
    white-space: nowrap;
    color: ${(props) => props.$color || 'inherit'};
`;

const Circle = styled(BiCircle)`
    margin-right: 2px;
`;

export const Badge: FC<BadgeProps> = ({ badgeColor, color, showCircle, children, className }) => {
    return (
        <StyledBadge className={className} $badgeColor={badgeColor} $color={color}>
            {showCircle && <Circle color={tint(badgeColor, -16)} />}
            {children}
        </StyledBadge>
    );
};

interface BadgeColorProps {
    children?: string;
    className?: string;
}

export const BadgeGreen: FC<BadgeColorProps> = (props) => (
    <Badge className={props.className} badgeColor='#d6f3e2' color='#065f46'>
        {props.children}
    </Badge>
);

export const BadgeYellow: FC<BadgeColorProps> = (props) => (
    <Badge className={props.className} badgeColor='#fef3c7' color='#92400e'>
        {props.children}
    </Badge>
);

export const BadgeRed: FC<BadgeColorProps> = (props) => (
    <Badge className={props.className} badgeColor='#fee2e2' color='#991b1b'>
        {props.children}
    </Badge>
);

export const BadgeGray: FC<BadgeColorProps> = (props) => (
    <Badge className={props.className} badgeColor='#f3f4f6' color='#374151'>
        {props.children}
    </Badge>
);

export const BadgeBlue: FC<BadgeColorProps> = (props) => (
    <Badge className={props.className} badgeColor='#dbeafe' color='#1e40af'>
        {props.children}
    </Badge>
);
